<template lang="pug">
  #container
    el-button(
      type="primary"
      size="medium"
      @click="exportarSelecionado"
      :disabled="disabled"
    ) Exportar
      i(:class="carregando ? 'fal far fa-circle-notch fa-spin' : 'fas fa-download'")
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'BotaoExportarSelecionado',
  props: {
    dadosFiltro: {
      required: true
    },
    selecionadoCondicao: {
      type: Boolean,
      required: true,
      default: true
    },
    tab: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    },
    carregando: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      novoDadosFiltro: null
    }
  },

  methods: {
    ...mapActions({
      exportarCsvStatus: 'filtros/exportarCsvStatus',
      exportarCsvAssunto: 'filtros/exportarCsvAssunto',
      exportarCsvPeriodoMensal: 'filtros/exportarCsvPeriodoMensal',
      exportarCsvPeriodoSemanal: 'filtros/exportarCsvPeriodoSemanal',
      exportarCsvPeriodoDiario: 'filtros/exportarCsvPeriodoDiario',
      exportarCsvResponsavel: 'filtros/exportarCsvResponsavel',
      exportarCsvListagemConversas: 'filtros/exportarCsvListagemConversas'
    }),

    async exportarSelecionado () {
      if (this.selecionadoCondicao) {
        this.$emit('exportar-img-grafico')
      } else {
        switch (this.tab) {
          case 'status':
            await this.exportarCsvStatus(this.novoDadosFiltro)
            break
          case 'assunto':
            await this.exportarCsvAssunto(this.novoDadosFiltro)
            break
          case 'responsavel':
            await this.exportarCsvResponsavel(this.novoDadosFiltro)
            break
          case 'periodoMensal':
            await this.exportarCsvPeriodoMensal(this.novoDadosFiltro)
            break
          case 'periodoSemanal':
            await this.exportarCsvPeriodoSemanal(this.novoDadosFiltro)
            break
          case 'periodoDiario':
            await this.exportarCsvPeriodoDiario(this.novoDadosFiltro)
            break
          case 'listagemConversas':
            await this.exportarCsvListagemConversas(this.novoDadosFiltro)
            break
        }
      }
    }
  },
  watch: {
    handler () {
      this.$emit('click', this.novoDadosFiltro || null)
    },
    dadosFiltro: {
      immediate: true,
      handler () {
        if (this.novoDadosFiltro !== this.dadosFiltro) {
          this.novoDadosFiltro = this.dadosFiltro
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  i {
    margin-left: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/BotaoExportarSelecionado.vue